import DashboardLayout from '@/layouts/DashboardLayout.vue'

export default {
  DashboardLayout
}
